var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBillingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.55,
    height: 13.333,
    viewBox: "0 0 7.55 13.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "billing-icon",
    d: "M12.42,15.742v1.592H10.195V15.725A3.1,3.1,0,0,1,7.47,12.892H9.1c.083.875.683,1.558,2.208,1.558,1.633,0,2-.817,2-1.325,0-.692-.367-1.342-2.225-1.783C9.02,10.842,7.6,9.992,7.6,8.283a2.889,2.889,0,0,1,2.592-2.675V4H12.42V5.625A2.946,2.946,0,0,1,14.8,8.45H13.162c-.042-.925-.533-1.558-1.85-1.558-1.25,0-2,.567-2,1.367,0,.7.542,1.158,2.225,1.592s3.483,1.158,3.483,3.258c-.008,1.525-1.15,2.358-2.6,2.633Z",
    transform: "translate(-7.47 -4)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingIcon);
export default __webpack_public_path__ + "static/media/billing-icon.3c864f53.svg";
export { ForwardRef as ReactComponent };